import type { SVGAttributes } from 'react';

export function HeartIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M19.86 8.09c0 .42-.03.83-.08 1.22a3.714 3.714 0 0 0-4.46 1.18C14.64 9.59 13.56 9 12.34 9c-2.05 0-3.71 1.67-3.71 3.74 0 2.68 1.42 4.73 3 6.12-.05.03-.1.04-.15.06-.3.11-.8.11-1.1 0C7.79 18.03 2 14.35 2 8.09 2 5.33 4.22 3.1 6.96 3.1c1.63 0 3.07.78 3.97 1.99A4.96 4.96 0 0 1 14.9 3.1c2.74 0 4.96 2.23 4.96 4.99"
				opacity=".4"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M21.999 12.74c0 4.68-4.33 7.44-6.27 8.1-.23.08-.6.08-.83 0-.83-.28-2.1-.95-3.27-1.98-1.58-1.39-3-3.44-3-6.12 0-2.07 1.66-3.74 3.71-3.74 1.22 0 2.3.59 2.98 1.49a3.714 3.714 0 0 1 4.46-1.18c1.31.58 2.22 1.89 2.22 3.43"
			/>
		</svg>
	);
}
